import { useCollectContext } from "components/widgets/CollectPage/CollectContextProvider"

export const useCentralizationInheritance = (inventoryType) => {
  const { collect } = useCollectContext()

  const centralizationType = collect?.centralization?.[inventoryType]
  const isInherited = centralizationType?.inherited === true

  return { isInherited, centralizationType }
}
